import { SORTING_DIRECTION } from '~/constants/main';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';

export enum KIOSKS_TABLE_COLUMN_NAME {
  ID = 'id',
  BRANCH = 'branch_name',
}

export interface IKiosksFilters {
  search: string;
  sortField: KIOSKS_TABLE_COLUMN_NAME | null;
  sortDir: SORTING_DIRECTION | null;
  branchOption: IPickerOption | null;
  statusOption: IPickerOption | null;
}
